import { render, staticRenderFns } from "./configurationTable.vue?vue&type=template&id=5e98071c"
import script from "./configurationTable.vue?vue&type=script&lang=js"
export * from "./configurationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports